import React, { useCallback, useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core';
import ChatWindow from '../ChatWindow/ChatWindow';
import ParticipantList from '../ParticipantList/ParticipantList';
import MainParticipant from '../MainParticipant/MainParticipant';
import BackgroundSelectionDialog from '../BackgroundSelectionDialog/BackgroundSelectionDialog';
import useChatContext from '../../hooks/useChatContext/useChatContext';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { LocalAudioTrack } from 'twilio-video';
import useIsTrackEnabled from '../../hooks/useIsTrackEnabled/useIsTrackEnabled';
import Cookies from 'universal-cookie';
const useStyles = makeStyles((theme: Theme) => {
  const totalMobileSidebarHeight = `${theme.sidebarMobileHeight +
    theme.sidebarMobilePadding * 2 +
    theme.participantBorderWidth}px`;
  return {
    container: {
      position: 'relative',
      height: '100%',
      display: 'grid',
      gridTemplateColumns: `1fr ${theme.sidebarWidth}px`,
      gridTemplateRows: '100%',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: `100%`,
        gridTemplateRows: `calc(100% - ${totalMobileSidebarHeight}) ${totalMobileSidebarHeight}`,
      },
    },
    rightDrawerOpen: { gridTemplateColumns: `1fr ${theme.sidebarWidth}px ${theme.rightDrawerWidth}px` },
  };
});
var response = {
  code: 100,
  data: {
    firstName: '',
    lastName: '',
    roomName: '',
  },
};
export default function Room() {
  // useEffect(() => {
  //   const cookies = new Cookies();
  //   if (cookies.get('hostType') === 'participant') {
  //     toggleAudioEnable();
  //     const interval = setInterval(() => {
  //       // console.log('Logs every minute');
  //       const queryParams = new URLSearchParams(window.location.search);

  //       const uid = queryParams.get('uid');

  //       const fullAPI = `${process.env.REACT_APP_ENDPOINT}/twillio/checkmutestatus?` + 'uuid=' + uid;

  //       fetch(fullAPI)
  //         .then(res => res.json())
  //         .then(booksList => {
  //           response.data = booksList;
  //           if (booksList.data.mute === 'Y') {
  //             // console.log("Sharad", "if : ")
  //             toggleAudioEnable();
  //           } else {
  //             // console.log("Sharad", "else : ")
  //           }
  //         })
  //         .catch(console.log);
  //     }, MINUTE_MS);

  //     return () => clearInterval(interval);
  //   }
  // }, []);

  const MINUTE_MS = 5000;
  const { localTracks } = useVideoContext();
  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;
  const isEnabled = useIsTrackEnabled(audioTrack);

  const toggleAudioEnable = useCallback(() => {
    if (audioTrack) {
      audioTrack.disable();
    }
  }, [audioTrack]);

  const toggleAudioDisable = useCallback(() => {
    if (audioTrack) {
      audioTrack.enable();
    }
  }, [audioTrack]);
  const classes = useStyles();
  const { isChatWindowOpen } = useChatContext();
  const { isBackgroundSelectionOpen } = useVideoContext();
  return (
    <div
      className={clsx(classes.container, {
        [classes.rightDrawerOpen]: isChatWindowOpen || isBackgroundSelectionOpen,
      })}
    >
      <MainParticipant />
      <ParticipantList />
      <ChatWindow />
      <BackgroundSelectionDialog />
    </div>
  );
}
